import { render } from "./TreeCheckboxDropdownItem.vue?vue&type=template&id=6505908b&scoped=true"
import script from "./TreeCheckboxDropdownItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeCheckboxDropdownItem.vue?vue&type=script&setup=true&lang=js"

import "./TreeCheckboxDropdownItem.vue?vue&type=style&index=0&id=6505908b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6505908b"],['__file',"src/components/scpm/components/TreeCheckboxDropdown/TreeCheckboxDropdownItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6505908b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6505908b', __exports__)) {
    api.reload('6505908b', __exports__)
  }
  
  module.hot.accept("./TreeCheckboxDropdownItem.vue?vue&type=template&id=6505908b&scoped=true", () => {
    api.rerender('6505908b', render)
  })

}


export default __exports__